import BrainVisualization from "./BrainVisualization";

const WelcomeComponent = () => (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">

        <div className="absolute inset-0 z-0">
            <BrainVisualization
                className="w-full h-full opacity-70"
            />
        </div>


        <div id="three-container" className="absolute inset-0"></div>
        <div className="absolute inset-0 bg-gradient-to-br from-orange-500/10 via-transparent to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-transparent to-orange-500/5"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-6xl sm:text-7xl lg:text-8xl font-black tracking-tight mb-8">
                <span className="block text-white">Uwolnij potencjał</span>
                <span
                    className="block text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600 h-28">myśli</span>
            </h1>
            <p className="mt-6 max-w-2xl mx-auto text-xl sm:text-2xl text-white font-light">
                Narzędzia i interfejsy encefalograficzne do badań i rozrywki
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-6 justify-center">
                <a href="#ourplans"
                   className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-black bg-gradient-to-r from-orange-400 to-orange-600 rounded-full overflow-hidden transition-all duration-300 hover:scale-105">
                    <span className="relative z-10">Zobacz nasze plany</span>
                </a>
                <a href="#aboutus"
                   className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white border-2 border-orange-500/50 rounded-full overflow-hidden transition-all duration-300 hover:border-orange-500 hover:text-orange-500">
                    <span className="relative z-10">Poznaj Nas</span>
                </a>
            </div>
        </div>
    </section>


)

export default WelcomeComponent
